import React, { useRef, useState, useEffect, forwardRef, useImperativeHandle } from "react";
import BundledEditor from "../Text/BundleEditor";
import rgbHex from "rgb-hex";
import * as UTILS from "../../../utils/Utils";
import { useTinyStyleFormats } from "../Text/useTinyStyleFormats";
import tinyStyles from "../TABLE/tableUtils";
import { chatbotTest } from "./Html";

const TinyMCEHTMLEditor = forwardRef((props, ref) => {
  const { formats } = useTinyStyleFormats(props);
  const editorRef = useRef(null);

  const [state, setState] = useState({
    googleFonts: UTILS.googleFontsEditor,
    presetColors: props.preset,
    link_list: props.pagesList,
    editorBlur: false,
    key: 0,
  });

  useEffect(() => {
    //
    let presetArray = [];
    props.preset
      ? props.preset.map((item) => {
        presetArray.push(item.replace(/#\b/g, ""));
        presetArray.push("black");
      })
      : "";
    setState({
      ...state,
      presetColors: presetArray,
      key: state.key + 1,
    });
  }, [
    props.layout,
    props.preset,
    props.elementsFont,
    props.selectedFont,
    props.content,
  ]);

  // Expose editor methods to parent component
  useImperativeHandle(ref, () => ({
    getContent: () => {
      return editorRef.current ? editorRef.current.getContent() : '';
    },
    setContent: (content) => {
      if (editorRef.current) {
        editorRef.current.setContent(content);
      }
    }
  }));
  const [processContent, setProcessContent] = useState(false);
  useEffect(() => {
    if (processContent) {
      const editor = editorRef.current;
      const container = editor.selection.getNode();
      if (!container) return;

      const listItems = container.querySelectorAll("li");
      if (listItems.length > 0) {
        listItems.forEach((li) => {
          const treeWalker = document.createTreeWalker(
            li,
            NodeFilter.SHOW_TEXT,
            {
              acceptNode: (node) => {
                const text = node.nodeValue.trim();
                return text.length > 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
              }
            },
            false
          );

          let hasValidText = false;
          while (treeWalker.nextNode()) {
            hasValidText = true;
          }

          if (!hasValidText) {
            li.remove();
          }
        });


        listItems.forEach((li) => {
          const treeWalker = document.createTreeWalker(
            li,
            NodeFilter.SHOW_TEXT,
            null,
            false
          );

          let currentNode;
          while ((currentNode = treeWalker.nextNode())) {
            if (currentNode.nodeValue.includes("\uFEFF")) {
              currentNode.nodeValue = currentNode.nodeValue.replace(/\uFEFF/g, "");
            }
          }
        });
      }

      setProcessContent(false);
    }
  }, [processContent]);

  return (
    <>
      <BundledEditor
        key={state.key}
        onInit={(evt, editor) => {
          editorRef.current = editor;
          setTimeout(() => {
            editor.execCommand("mceCodeEditor");
          }, 0);
        }}
        initialValue={props.content}
        init={{
          selector: `#${props.ID}`,
          height: 600,


          plugins:
            "table lists advlist link code advtable powerpaste charmap emoticons",
          promotion: false,

          toolbar: [
            "undo redo  customInsertButton |  styles fontfamily fontsizeinput| table | bold italic underline strikethrough customInsertButton | alignleft aligncenter alignright alignjustify | outdent indent | link  lineheight | numlist bullist | forecolor backcolor  | pagebreak | charmap emoticons | insertfile image media template link anchor |  code | ltr rtl",
          ],
          paste_block_drop: true,
          table_border_styles: [
            { title: "Solid", value: "solid" },
            { title: "Dotted", value: "dotted" },
            { title: "Dashed", value: "dashed" },
            { title: "Double", value: "double" },
            { title: "Groove", value: "groove" },
            { title: "Ridge", value: "ridge" },
            { title: "Inset", value: "inset" },
            { title: "Outset", value: "outset" },
            { title: "None", value: "none" },
            { title: "Hidden", value: "hidden" },
          ],
          powerpaste_allow_local_images: true,
          powerpaste_word_import: "prompt",
          powerpaste_html_import: "prompt",
          table_grid: false,
          table_default_attributes: {
            cellPadding: "20px",
            width: "100%",
            border: "1px",
            borderColor: "black",
            borderStyle: "solid",
          },
          table_default_styles: {
            "border-collapse": "collapse",
            "border-color": "black",
            "border-style": "solid",
            "border-width": "1px",
          },
          object_resizing: true,
          table_resize_bars: true,
          content_style: "td{border:black solid 1px;}",
          line_height_formats:
            "1 1.1 1.2 1.25 1.3 1.4 1.4 1.4 1.4 1.4 1.4 1.4 1.5 2",
          color_map: state.presetColors
            ? ["ffffff", "white", "000000", "black", ...state.presetColors]
            : ["ffffff", "black", "white", "00000"],
          cleanup: true,
          font_family_formats: UTILS.googleFontsEditor,
          statusbar: true,
          elementpath: true,
          forced_root_block: "div",
          forced_root_block_attrs: {
            style: `font-family:${props.selectedFont}; font-size:14px;`,
          },
          browser_spellcheck: true,
          link_default_protocol: "http",
          link_list: props.pagesList,
          link_default_target: "_blank",
          formats: formats,
          style_formats: tinyStyles.style_formats,

          protect: [/<div id="chat_[^"]*"[\s\S]*?<\/script>/gi],
          sandbox_iframes: false,
          valid_elements: '*[*]', // Permite todos los elementos y atributos
          extended_valid_elements: '*[*]',
          allow_html_in_named_anchor: true,
          verify_html: false,
          valid_children: '+body[style|script|iframe|svg|path|div|*]',
          setup: (editor) => {
            editor.ui.registry.addButton("customInsertButton", {
              tooltip: "Clear Formatting",
              icon: "remove-formatting",
              onAction: function (e) {

                const selectedContent = editor.selection.getContent();

                if (selectedContent.includes('<li>') || selectedContent.includes('<ul>') || selectedContent.includes('<ol>')) {
                  editor.execCommand('RemoveList');
                }


                tinymce.activeEditor.formatter.apply("noneForRemoveFormat");
                editor.formatter.remove("strikethrough");
                editor.execCommand("RemoveFormat");
                editor.execCommand("RemoveFormat");
              },
            });

            // Change Source Code window title
            editor.editorManager.i18n.add('en', {
              'Source code': 'HTML Editor - Source Code'
            });
            editor.on('ExecCommand', (e) => {
              if (e.command === 'mceCodeEditor') {
                setTimeout(() => {
                  const dialog = document.querySelector('.tox-dialog');
                  if (dialog) {
                    // Find the textarea or code editor input
                    const textarea = dialog.querySelector('textarea');
                    // Find the Save button using the correct selector
                    const saveButton = dialog.querySelector('button[aria-label="Save"][data-mce-name="Save"]');
                    const closeButton = dialog.querySelector('button[aria-label="Close"][data-mce-name="close"]');
                    if (closeButton && textarea) {
                      closeButton.onclick = null;
                      closeButton.addEventListener('click', function handler() {
                        closeButton.removeEventListener('click', handler);
                        const isChatbot = chatbotTest.test(textarea.value);
                        if (isChatbot) {
                          props.handleClosePopup();
                        }
                      });
                    }
                    const cancelButton = dialog.querySelector('button[aria-label="Cancel"][data-mce-name="Cancel"]');
                    if (cancelButton && textarea) {
                      cancelButton.addEventListener('click', function handler() {
                        cancelButton.removeEventListener('click', handler);
                        const isChatbot = chatbotTest.test(textarea.value);
                        if (isChatbot) {
                          // Use the handleCancel function to properly restore content
                          props.handleCancel();
                        }
                      });
                    }
                    if (saveButton && textarea) {
                      // Remove previous handler if any
                      saveButton.onclick = null;
                      saveButton.addEventListener('click', function handler() {
                        saveButton.removeEventListener('click', handler);
                        const isChatbot = chatbotTest.test(textarea.value);
                        if (isChatbot) {
                          // Update the editor content with the textarea value
                          // editor.setContent(textarea.value);
                          props.onEditorChange(textarea.value);
                          props.handleClosePopup();
                        }
                      });
                    }
                    if (textarea && !textarea.value) {
                      textarea.placeholder = 'Enter your HTML code here...'; // Set your placeholder text
                    }
                  }
                }, 0);
              }

              // STYLE FORMAT COMMANDS`
              const selectedContent = editor.selection.getContent({ format: 'html' });
              if (e.command === "mceToggleFormat") {
                // formats

                if (["p", "div", "h1", "h2", "h3", "h4"].includes(e.value)) {
                  const formatName = e.value;
                  if (selectedContent.includes('<ul>') || selectedContent.includes('<ol>')) {
                    setProcessContent(true);
                    console.log("selectedContent", selectedContent);
                    editor.formatter.apply(formatName + "_list");
                    e.preventDefault();
                  } else {
                    editor.formatter.apply(formatName);
                    e.preventDefault();
                  }
                }


                if (selectedContent.includes('<ul>') || selectedContent.includes('<ol>')) {
                  const node = editor.selection.getNode();
                  const liNode = node.querySelector('li');

                  switch (e.value) {
                    case "bold":
                      liNode.style.fontWeight = "bold";
                      break;
                    case "italic":
                      liNode.style.fontStyle = "italic";
                      break;
                  }

                }
              }

              if (e.command === "mceApplyTextcolor") {
                if (selectedContent.includes('<ul>') || selectedContent.includes('<ol>')) {
                  const node = editor.selection.getNode();
                  const liNode = node.querySelector('li');
                  if (liNode) {
                    const existingStyle = liNode.getAttribute('style') || '';
                    const cleanedStyle = existingStyle.replace(/color\s*:\s*[^;]+;?/i, '').trim();
                    const newStyle = `${cleanedStyle} color: ${e.value};`.trim();
                    liNode.setAttribute('style', newStyle);
                    liNode.setAttribute('data-mce-style', newStyle);
                  }
                }
              }
              if (e.command === 'FontSize') {
                if (selectedContent.includes('<ul>') || selectedContent.includes('<ol>')) {
                  const node = editor.selection.getNode();
                  const liNode = node.querySelector('li');
                  if (liNode) {
                    const existingStyle = liNode.getAttribute('style') || '';
                    const cleanedStyle = existingStyle.replace(/font-size\s*:\s*[^;]+;?/i, '').trim();
                    const newStyle = `${cleanedStyle} font-size: ${e.value};`.trim();
                    liNode.setAttribute('style', newStyle);
                    liNode.setAttribute('data-mce-style', newStyle);
                  }
                }
              }
              if (e.command === 'FontName') {
                if (selectedContent.includes('<ul>') || selectedContent.includes('<ol>')) {
                  const node = editor.selection.getNode();
                  const liNode = node.querySelector('li');
                  if (liNode) {
                    const existingStyle = liNode.getAttribute('style') || '';
                    const cleanedStyle = existingStyle.replace(/font-family\s*:\s*[^;]+;?/i, '').trim();
                    const newStyle = `${cleanedStyle} font-family: ${e.value};`.trim();
                    liNode.setAttribute('style', newStyle);
                    liNode.setAttribute('data-mce-style', newStyle);
                  }
                }
              }

              // // LIST COMMANDS
              if (e.command === 'InsertUnorderedList' || e.command === 'InsertOrderedList') {
                if (selectedContent.includes('<ul>') || selectedContent.includes('<ol>')) {
                  setProcessContent(true);

                  const node = editor.selection.getNode();
                  const list = node.querySelectorAll('li');
                  list.forEach((li) => {
                    if (!li.innerText.trim()) {
                      li.remove();
                    }
                  });
                }
              }
            });
          },
        }}
      />
      {/* <button onClick={log}>Log editor content</button> */}
    </>
  );
});

export default TinyMCEHTMLEditor;
